import * as React from 'react';
import { useState } from 'react';
import useFetchTeacherAssignments from 'chameleon/ui-stack/hooks/use-assignments-fetch/teacher';

import Context from '../state/context';

function TeacherAssignmentsProvider({ children }) {
  /**
   * A map of assignment ID to the details of the full object
   * to allow easy lookup
   */
  const [assignments, setAssignments] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [getTeacherAssignments] = useFetchTeacherAssignments();

  const addAssignments = async () => {};

  const updateAssignment = async () => {};

  const updateAssignments = async () => {};

  const deleteAssignment = async () => {};

  const loadAssignments = async () => {
    setIsLoading(true);
    getTeacherAssignments();
    setAssignments([]);
    setIsLoading(false);
  };

  const loadAssignment = async () => {};

  const value = {
    state: {
      isLoading,
      assignments,
    },
    actions: {
      addAssignments,
      updateAssignment,
      updateAssignments,
      deleteAssignment,
      loadAssignments,
      loadAssignment,
    },
  };
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export { TeacherAssignmentsProvider };
